<template>
  <div class="animated fadeIn">
    <b-card header="Companies">
      <div slot="header">
        <div class="d-flex justify-content-between">
          <div><strong>Companies</strong></div>
        </div>
      </div>
      <b-row v-if="admin.level <= 1">
        <b-col md="12" class="pb-4">
          <router-link class="btn btn-primary" to="register">
            <i class="fa fa-plus"></i>&nbsp;Add New
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="my-1">
          <div class="d-flex">
            <div class="pt-1">Per Page:</div>
            <b-form-group class="mb-0 pl-2">
              <b-form-select :options="pageOptions" v-model="perPage" class="mb-1" />
            </b-form-group>
          </div>
        </b-col>
        <b-col md="6" class="my-1">
          <div class="float-right">
            <div class="d-flex">
              <div class="pt-1">Search:</div>
              <b-form-group class="mb-0 pl-2">
                <b-input-group class="mb-1">
                  <b-form-input v-model="filter" placeholder="Type to Search"  />
                </b-input-group>
              </b-form-group>
            </div>
          </div>
        </b-col>
      </b-row>
      <div class="row">
        <b-col md="12" class="my-1">
          <b-table show-empty
                   striped
                   responsive="sm"
                   :items="companies"
                   :fields="filteredFields"
                   :current-page="currentPage"
                   :per-page="perPage"
                   :filter="filter"
                   @filtered="onFiltered"
            >
            <template slot="name" slot-scope="data">
              <router-link :to="'' + data.item.company_id">
                {{data.item.name}}
              </router-link>
            </template>
            <template slot="address" slot-scope="data">
              {{data.value.street_address}}
              {{data.value.city}},
              {{data.value.province}}
              {{data.value.postal_code}}
            </template>
            <template slot="edit" slot-scope="data">
              <router-link class="btn btn-success btn-block" :to="'edit/' + data.item.company_id">
                <i class="fa fa-edit"></i>&nbsp;Edit
              </router-link>
            </template>
            <template slot="delete" slot-scope="data">
              <button class="btn btn-danger btn-delete-open" @click="confirmDelete('company', data.item.company_id)">
                <i class="fa fa-trash"></i>&nbsp;Delete
              </button>
            </template>
          </b-table>
          <b-row>
            <b-col md="6" class="my-1">
              Showing {{showingFrom}} - {{showingTo}} of {{totalRows}} companies
            </b-col>
            <b-col md="6" class="my-1">
              <div class="float-right">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons />
              </div>
            </b-col>
          </b-row>
        </b-col>
      </div>
      <b-row v-if="admin.level <= 1">
        <b-col md="12" class="pb-4">
          <router-link class="btn btn-primary" to="register">
            <i class="fa fa-plus"></i>&nbsp;Add New
          </router-link>
        </b-col>
      </b-row>
    </b-card>
    <modal name="confirm-delete-company" height="auto" :adaptive="true" @before-open="deleteCompanyOpen" style="z-index: 10000;">
      <div class="container">
        <b-row class="row-top-delete">
          <b-col xs="10" class="my-1">
            <h2>Delete Company</h2>
          </b-col>
          <b-col xs="2" class="my-1">
            <button type="button" class="close" @click="$modal.hide('confirm-delete-company')" aria-hidden="true">&times;</button>
          </b-col>
        </b-row>
        <b-row class="row-middle-delete">
          <b-col xs="12" class="my-1">
            <p>Are you sure you want to delete this company? This process cannot be undone.</p>
          </b-col>
        </b-row>
        <b-row class="row-bottom-delete">
          <b-col xs="12" class="my-1">
            <div class="d-flex float-right modal-buttons">
              <b-button @click="$modal.hide('confirm-delete-company')">Cancel</b-button>
              <button class="btn btn-danger btn-delete" @click="deleteCompany(); $modal.hide('confirm-delete-company')">
                Delete
              </button>
            </div>
          </b-col>
        </b-row>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import confirmDelete from './../../mixins/confirmDelete'
import filteredFields from './../../mixins/filteredFields'
import getAdmin from './../../mixins/getAdmin'
import onFiltered from './../../mixins/onFiltered'
import showingFrom from './../../mixins/showingFrom'
import showingTo from './../../mixins/showingTo'

export default {
  name: 'Companies',
  mixins: [
    confirmDelete,
    filteredFields,
    getAdmin,
    onFiltered,
    showingFrom,
    showingTo
  ],
  data: () => {
    return {
      admin: {},
      currentPage: 1,
      fields: [
        {key: 'name', sortable: true},
        {key: 'address'},
        {key: 'edit'},
        {key: 'delete'}
      ],
      filter: null,
      pageOptions: [ 5, 10, 15, 20, 25, 50 ],
      perPage: 5,
      totalRows: 0
    }
  },
  computed: {
    ...mapGetters([
      'companies'
    ])
  },
  watch: {
    /**
     * Updates the total number of companies whenever companies array is updated.
     */
    companies () {
      this.totalRows = this.companies.length
    }
  },
  methods: {
    /**
     * Dispatches the deleteCompany action in the Vuex store to soft delete a company in the backend API.
     */
    deleteCompany () {
      this.$store.dispatch('deleteCompany', {
        company_id: this.company_id,
        notify: this.$notify,
        level: this.admin.level
      })
    },
    /**
     * Function that is evoked when delete modal box is opened.
     * @param {object} event - The event object that is fired.
     */
    deleteCompanyOpen (event) {
      this.company_id = event.params.id
    },
    /**
     * Dispatches an event to get all the companies the authenticated admin has access to.
     */
    getCompanies () {
      if (this.admin.level === 0) {
        this.$store.dispatch('getAllCompanies')
      } else {
        this.$store.dispatch('getAdminCompanies')
      }
    }
  },
  async mounted () {
    await this.getAdmin()
    this.getCompanies()
  }
}
</script>
